export default __webpack_public_path__ + "static/mw-0d52472f54b74499d5bb4a2828fc63ab.svg";